import React from "react";
import {
  IS_PROD,
  KEYWORDS,
  ORGANIZATION_DESCRIPTION,
  ORGANIZATION_LOGO,
  ORGANIZATION_NAME,
  ORGANIZATION_TITLE,
  ORGANIZATION_URL,
} from "../src/recourses/constants";
import organizationSchema from "../src/recourses/schemaOrg/organizationSchema";
import { type PropsWithChildren } from "react";
import { Helmet } from "react-helmet-async";

type BaseSEOProps = PropsWithChildren<{
  showBase?: boolean;
  showOG?: boolean;
  showTwitter?: boolean;
  url: string;
}>;

const BaseSEO = ({ children, url, showBase = true, showOG = true, showTwitter = true }: BaseSEOProps) => {
  return (
    <>
      {!IS_PROD && (
        <Helmet prioritizeSeoTags>
          <meta name="robots" content="noindex" />
          <meta name="googlebot" content="noindex" />
        </Helmet>
      )}

      <Helmet prioritizeSeoTags>
        <meta name="application-name" content={ORGANIZATION_NAME} />
        <link rel="author" href={ORGANIZATION_URL} />
        <meta name="author" content={ORGANIZATION_NAME} />
        <link rel="canonical" href={url} />
        <link rel="image_src" href={ORGANIZATION_LOGO} />
        <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      </Helmet>

      {showBase && (
        <Helmet prioritizeSeoTags>
          <title>{ORGANIZATION_TITLE}</title>
          <meta name="description" content={ORGANIZATION_DESCRIPTION} />
          <meta name="keywords" content={KEYWORDS.join(", ")} />
        </Helmet>
      )}

      {showOG && (
        <Helmet prioritizeSeoTags>
          <meta property="og:title" content={ORGANIZATION_TITLE} />
          <meta property="og:description" content={ORGANIZATION_DESCRIPTION} />
          <meta property="og:url" content={ORGANIZATION_URL} />
          <meta property="og:site_name" content={ORGANIZATION_NAME} />
          <meta property="og:image" content={ORGANIZATION_LOGO} />
        </Helmet>
      )}

      {showTwitter && (
        <Helmet prioritizeSeoTags>
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={ORGANIZATION_TITLE} />
          <meta name="twitter:description" content={ORGANIZATION_DESCRIPTION} />
          <meta name="twitter:image" content={ORGANIZATION_LOGO} />
        </Helmet>
      )}

      {children}
    </>
  );
};

export default BaseSEO;
